import { atomWithDefault } from 'jotai/utils';
import { segmentsAtom } from './segmentsAtom';

export const selectedSegmentIdAtom = atomWithDefault<string>(
  (get) => get(segmentsAtom)[0]?.id
);
